import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import useRequest from "../../../hooks/useRequest";
import Breadcrumb from "../../Breadcrumb/Breadcrumb";
import { useSelector } from "react-redux";

import {
  Input,
  RenderInputFields,
  SubmitButton,
  CKEditorInput,
  Textarea,SubInput,
  SubTab
} from "../../Form/Form";
import { compareChanges } from "../../../util/fn";
import { CHANGES_REQ_MESSAGE } from "../../../util/other";


const Add = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    control,
    setValue,
    trigger,
    getValues,
    clearErrors,
    reset
  } = useForm();

  const ckEditorRef = useRef();
  const { response, request } = useRequest();
  const { languages } = useSelector((state) => state.setting);
  const { response: responseBanner, request: requestBanner } = useRequest();

  const [image, setImage] = useState();
  const [displayImage, setDisplayImage] = useState();
  const [recordId, setRecordId] = useState();
  const [oldValues, setOldValues]                     = useState([]);

  useEffect(() => {
    document.title = "Banner - Calevalab";
    requestBanner("GET", "home-banner");
  }, [response]);

  useEffect(() => {
    if (responseBanner) {
      if (responseBanner.data ) {
        const {langData,image,link, linkLabel, description, heading, title} = responseBanner?.data ?? {};

        if (responseBanner.data._id) {
          setRecordId(responseBanner.data?._id);
        }
        if (responseBanner.data.image) {
          setImage(responseBanner.data.image);
          setValue("image", responseBanner.data?.image);
        }
        if (responseBanner.data.video) {
          setValue("video", responseBanner.data?.video);
        }
        if (responseBanner.data.description) {
          setValue("description", responseBanner.data?.description);
        }


        // const langDataWithoutId = langData.map(({ _id: _, ...rest }) => rest);
  
        const langDataWithoutId = langData.map(({ _id: _, ...rest }) => rest);
      
        const langDataShortedOld = langDataWithoutId.sort((a, b) => a.languageCode.localeCompare(b.languageCode));
        setOldValues({
          image: image,
          link: link,
          langData:langDataShortedOld
        });

        const subData = {};
        if (langData?.length > 0) {
          langData.forEach((lang) => {
            const code = lang?.languageCode;
            subData["title-" + code] = lang?.title;
            subData["heading-" + code] = lang?.heading;
            subData["description-" + code] = lang?.description;
            subData["linkLabel-" + code] = lang?.linkLabel;
            subData["id-" + code] = lang?._id;
          });
          reset({ ...subData });
        }

        
        setValue("title", title);
        setValue("description", description);
        setValue("linkLabel", linkLabel);
        setValue("image", image);
        setValue("link", link);
        setValue("heading", heading);
        setImage(image)

      }
    }
  }, [responseBanner]);

  useEffect(() => {
   
    if (response) {
      if (response.data) {
       
        if (response.data._id) {
          setRecordId(response.data._id);
        }
        if (response.data.image) {
          setImage(response.data.image);
          setValue("image", response.data.image);
        }
        if (response.data.video) {
          setValue("video", response.data.video);
        }
        if (response.data.description) {
          setValue("description", response.data.description);
        }
        if (response.data.features && response.data.features.length > 0) {
          response.data.features.forEach((obj, index) => {
            setValue(`title${index + 1}`, obj.title);
            setValue(`description${index + 1}`, obj.description);
          });
        }
      }
      setDisplayImage(null);
      if (document.getElementById("image")) {
        document.getElementById("image").value = "";
      }
      toast.success(response.message);
    }
  }, [response]);

  const onSubmit = (data) => {
    const langData                     = [];
    const {
      description,
      video,
      link
    } = data;

    let fd = new FormData();

    for (let i = 0; i < languages.length; i++) {
      const code = languages[i].code;

      if (languages[i].default) {
        fd.append("description", data[`description-${code}`]);
        fd.append("linkLabel", data[`linkLabel-${code}`]);
        fd.append("title", data[`title-${code}`]);
        fd.append("heading", data[`heading-${code}`]);
      
      }
   
      
      langData.push({ id: data[`id-${code}`],languageCode:code, description: data[`description-${code}`], linkLabel: data[`linkLabel-${code}`], title: data[`title-${code}`], heading: data[`heading-${code}`]});
    }


    if (displayImage) {
      if (data.image && data.image.length > 0) {
        fd.append("file", data.image[0]);
      }
    } else {
      if (image) {
        fd.append("old_image", image);
      }
    }

    fd.append("link", link);

    if (recordId) {
      fd.append("id", recordId);
    }
    fd.append("video", video);

    const langDataWithoutId = langData.map(({ id: _,  ...rest }) => rest);
    const langDataShorted = langDataWithoutId.sort((a, b) => a.languageCode.localeCompare(b.languageCode));

    let newData = {
      image: (data?.image?.length > 0 && data?.image[0]?.type) ? data.image[0] : image,
      link: data?.link,
      langData:langDataShorted
    };


    if(compareChanges(oldValues,newData)){
      fd.append("langData", JSON.stringify(langData));
      if (recordId) {
        request("PUT", "home-banner", fd);
      }else {
        request("POST", "home-banner", fd);
      }
    }
    else {
      toast.error(CHANGES_REQ_MESSAGE);
    }
  };

  const handleImage = (event) => {
    event.preventDefault();
    if (event.target.files[0]) {
      setDisplayImage(URL.createObjectURL(event.target.files[0]));
      setError("image", "");
    } else {
      setDisplayImage("");
      setImage("");
      setValue("image", "");
    }
  };

  const handleRemoveImage = () => {
    if (displayImage) {
      setDisplayImage(null);
      setValue("image", null);
    } else {
      setImage(null);
    }
    if (document.getElementById("image")) {
      document.getElementById("image").value = "";
    }
  };

  const InputFields = [
    [
      {
        Component: Input,
        placeholder: "Heading",
        label: "Heading",
        name: "heading",
        colClass: "col-lg-6",
        registerFields: {
          required: true,
          // pattern: /^[A-Za-z!@#$%^&*() ]+$/,
          setValueAs: (v) => v.trim(),
        },
      },
      {
        Component: Input,
        label: "Title",
        type: "text",
        name: "title",
        registerFields: {
          required: true,
          // pattern: /^[A-Za-z!@#$%^&*() ]+$/,
          setValueAs: (v) => v.trim(),
        },
      },
     
    ],
    [
      
      {
        Component: Textarea,
        placeholder: "Enter Description",
        label: "Description",
        name: "description",
        colClass: "col-lg-12",
        registerFields: {
          required: true,
          setValueAs: (v) => v.trim(),
        },
      },
      {
        Component: Input,
        label: "Link Label",
        type: "text",
        name: "linkLabel",
        registerFields: {
          required: true,
          // pattern: /^[A-Za-z!@#$%^&*() ]+$/,
          setValueAs: (v) => v.trim(),
        },
      },
    ],
  ];

  const InputFieldsImage = [
    [
      {
        Component: Input,
        label: "Image",
        type: "file",
        name: "image",
        registerFields: {
          required: true,
          setValueAs: (v) => v.trim(),
        },
        handleMedia: handleImage,
        handleRemoveMedia: handleRemoveImage,
        isMedia: true,
        accept: "image/*",
        control,
        image,
        displayImage,
        media: "image",
      },
      {
        Component: Input,
        label: "Link",
        type: "text",
        name: "link",
        registerFields: {
          required: true,
          setValueAs: (v) => v.trim(),
        },
      },
    ],
  ];

  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title="Banner"
        links={[
          { to: "/", name: "Dashboard" },
          // { to: "/home/service-descriptions", name: "Back To Service Descriptions" },
        ]}
      />

      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-xl-1"></div>
                <div className="col-xl-10">
                  <h3 className="mb-10 font-weight-bold text-dark">Banner</h3>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row"></div>
                    <div className="card card-custom gutter-b">
                      <div className="card-header card-header-tabs-line">
                        <div className="card-toolbar">
                          <ul
                            className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-bold nav-tabs-line-3x"
                            role="tablist"
                          >
                            {languages.length > 0 &&
                              languages.map((lang, index) => (
                                <SubTab
                                  key={index}
                                  name={lang.name}
                                  index={index}
                                  image={lang?.image}
                                />
                             ))}
                          </ul>
                        </div>
                      </div>
                      <div className="card-body px-0">
                        <div className="tab-content px-10">
                          {languages.length > 0 &&
                            languages.map((lang, index) => (
                              <>
                                <SubInput
                                  key={index}
                                  index={index}
                                  errors={errors}
                                  register={register}
                                  //   required={lang.default}
                                  required={true}
                                  InputFields={InputFields}
                                  code={lang.code}
                                />
                              </>
                            ))}
                        </div>
                        <div className="row"></div>
                      </div>
                    </div>
                    <div className="row"></div>
                  
                      <RenderInputFields
                        InputFields={InputFieldsImage}
                        errors={errors}
                        register={register}
                      />
                      
                    <SubmitButton
                      handleSubmit={handleSubmit}
                      onSubmit={onSubmit}
                      name="Submit"
                    />
                  </form>
                </div>
                <div className="col-xl-1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Add;
